export const variantMap = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body1: 'p',
  body2: 'p',
};

export const fontSizeMap = {
  h1: '40px',
  h2: '36px',
  h3: '24px',
  h4: '20px',
  h5: '18px',
  h6: '16px',
  body1: '16px',
  body2: '14px',
};

export const marginBlockMap = {
  h1: '0.5em',
  h2: '0.67em',
  h3: '0.83em',
  h4: '1.0625em',
  h5: '1.25em',
  h6: '1em',
  body1: '1em',
  body2: '1em',
};
